import React, { useEffect, useState, useRef, createElement } from 'react';
import { CheckIcon } from 'lucide-react';
declare global {
  interface Window {
    checkoutElements?: {
      init: (type: string) => {
        mount: (selector: string) => void;
      };
    };
  }
}
const GOLD_GRADIENT = 'linear-gradient(135deg, #C9A227 0%, #E8C766 100%)';
function formatTime(totalSeconds: number): string {
  const m = Math.floor(totalSeconds / 60);
  const s = totalSeconds % 60;
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}
const APRENDERAS = ['Cómo seguir conquistándose incluso después de muchos años.', 'Cómo evitar que la rutina vuelva a instalarse.', 'Cómo recuperar la cercanía en medio del trabajo, los hijos y las responsabilidades.', 'Cómo fortalecer la conexión emocional sin conversaciones incómodas.', 'Cómo hacer que la intimidad vuelva a sentirse natural.', 'Cómo construir pequeños hábitos que mantienen viva una gran relación.'];
function Divider() {
  return <div className="flex items-center justify-center gap-3 py-10 select-none" aria-hidden="true" data-id="element-0">
      {[0, 1, 2].map(i => <span key={i} className="h-1.5 w-1.5 rounded-full" style={{
      background: GOLD_GRADIENT
    }} data-id="element-1" />)}
    </div>;
}
function GoldCheck() {
  return <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full" style={{
    background: GOLD_GRADIENT
  }} data-id="element-2">
      <CheckIcon className="h-3.5 w-3.5 text-[#2B0F14]" strokeWidth={3} data-id="element-3" />
    </span>;
}
export function App() {
  const [secondsLeft, setSecondsLeft] = useState(599);
  const [showSticky, setShowSticky] = useState(false);
  // Countdown timer
  useEffect(() => {
    const interval = setInterval(() => {
      setSecondsLeft(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  // Hotmart sales funnel widget
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://checkout.hotmart.com/lib/hotmart-checkout-elements.js';
    script.async = true;
    script.onload = () => {
      if (window.checkoutElements) {
        window.checkoutElements.init('salesFunnel').mount('#hotmart-sales-funnel');
      }
    };
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  // Sticky bar visibility on scroll
  useEffect(() => {
    const onScroll = () => setShowSticky(window.scrollY > 400);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const scrollToOffer = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  const time = formatTime(secondsLeft);
  return <div className="min-h-screen w-full" style={{
    background: 'linear-gradient(180deg, #2B0F14 0%, #0D0608 100%)',
    color: '#F5ECE4'
  }} data-id="element-4">
      <main className="mx-auto w-full px-6 pb-40 pt-12 sm:pb-24" style={{
      maxWidth: 480
    }} data-id="element-5">
        {/* 1. BADGE DE CONFIRMACIÓN */}
        <div className="flex items-center justify-center" data-id="element-6">
          <div className="flex items-center gap-2.5 rounded-full border px-4 py-2" style={{
          borderColor: 'rgba(232,199,102,0.35)',
          background: 'rgba(232,199,102,0.06)'
        }} data-id="element-7">
            <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full" style={{
            background: GOLD_GRADIENT
          }} data-id="element-8">
              <CheckIcon className="h-3 w-3 text-[#2B0F14]" strokeWidth={3} data-id="element-9" />
            </span>
            <span className="text-[13px] font-medium leading-snug" style={{
            color: '#E8C766'
          }} data-id="element-10">
              Tu acceso a Kamasutra para Enamorar ya está confirmado.
            </span>
          </div>
        </div>

        {/* 2. BLOQUE DE INVITACIÓN */}
        <div className="mt-12 text-center" data-id="element-11">
          <p className="text-xs font-medium uppercase tracking-[0.25em]" style={{
          color: '#E8C766'
        }} data-id="element-12">
            Antes de continuar…
          </p>
          <div className="mt-6 space-y-4 text-[16px] font-light leading-[1.8]" style={{
          color: 'rgba(245,236,228,0.9)',
          letterSpacing: '0.01em'
        }} data-id="element-13">
            <p data-id="element-14">Quiero hacerte una invitación muy especial.</p>
            <p data-id="element-15">Lo que acabas de comprar puede cambiar una noche.</p>
            <p data-id="element-16">Lo que estás a punto de descubrir puede cambiar una relación.</p>
            <div className="py-2" data-id="element-17">
              <img src="https://cdn.magicpatterns.com/uploads/avJi25Zqa49LWDJLUWcmAm/Portada_OTO.jpg" alt="18 Métodos para Volver a Elegirse" className="mx-auto w-full max-w-[360px] rounded-xl border" style={{
              borderColor: 'rgba(232,199,102,0.25)',
              boxShadow: '0 12px 40px rgba(0,0,0,0.45)'
            }} data-id="element-18" />
            </div>
            <p data-id="element-19">Porque muchas parejas logran reconectar…</p>
            <p data-id="element-20">
              Pero pocas saben cómo mantener viva esa conexión con el paso del
              tiempo.
            </p>
            <p data-id="element-21">Y ahí comienza realmente el desafío.</p>
          </div>
        </div>

        <Divider data-id="element-22" />

        {/* 3. PRESENTACIÓN DEL PRODUCTO */}
        <div className="text-center" data-id="element-23">
          <p className="text-xs font-medium uppercase tracking-[0.25em]" style={{
          color: '#E8C766'
        }} data-id="element-24">
            Por eso la{' '}
            <span style={{
            color: '#E0879A'
          }} data-id="element-25">
              DOC
            </span>{' '}
            creó
          </p>
          <div className="relative mt-5" data-id="element-26">
            <span className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 select-none leading-none" style={{
            fontFamily: 'var(--serif)',
            fontWeight: 700,
            fontSize: 220,
            color: '#FFFFFF',
            opacity: 0.07
          }} aria-hidden="true" data-id="element-27">
              18
            </span>
            <h1 className="relative text-[32px] leading-tight sm:text-[38px]" style={{
            fontFamily: 'var(--serif)',
            fontWeight: 700,
            color: '#FFFFFF'
          }} data-id="element-28">
              18 Métodos para Volver a Elegirse
            </h1>
          </div>
          <p className="mx-auto mt-5 max-w-[400px] text-[16px] font-light italic leading-[1.7]" style={{
          color: 'rgba(245,236,228,0.9)'
        }} data-id="element-29">
            Cómo evitar que la rutina apague una relación que todavía merece ser
            vivida.
          </p>
        </div>

        <Divider data-id="element-30" />

        {/* 4. SECCIÓN "QUÉ SIGUE" */}
        <div className="text-center" data-id="element-31">
          <h2 className="text-[26px] leading-snug sm:text-[30px]" style={{
          fontFamily: 'var(--serif)',
          fontWeight: 600,
          color: '#E8C766'
        }} data-id="element-32">
            Después de Kamasutra… ¿Qué sigue?
          </h2>
          <div className="mt-6 space-y-4 text-[16px] font-light leading-[1.8]" style={{
          color: 'rgba(245,236,228,0.9)'
        }} data-id="element-33">
            <p data-id="element-34">
              La verdadera transformación ocurre cuando la conexión deja de
              depender de un momento especial…
            </p>
            <p data-id="element-35">Y comienza a convertirse en una forma de relacionarse.</p>
            <p data-id="element-36">
              En este entrenamiento descubrirás 18 acciones sencillas, profundas
              y aplicables, diseñadas para ayudarte a mantener viva la
              complicidad, la cercanía y el deseo todos los días.
            </p>
          </div>
        </div>

        <Divider data-id="element-37" />

        {/* 5. LISTA "LO QUE APRENDERÁS" */}
        <div data-id="element-38">
          <h3 className="text-center text-[22px] sm:text-[24px]" style={{
          fontFamily: 'var(--serif)',
          fontWeight: 600,
          color: '#FFFFFF'
        }} data-id="element-39">
            Lo que aprenderás
          </h3>
          <ul className="mt-8 space-y-5" data-id="element-40">
            {APRENDERAS.map(item => <li key={item} className="flex items-start gap-3.5" data-id="element-41">
                <GoldCheck data-id="element-42" />
                <span className="text-[16px] font-light leading-[1.7]" style={{
              color: 'rgba(245,236,228,0.9)'
            }} data-id="element-43">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        <Divider data-id="element-44" />

        {/* 6. SECCIÓN OFERTA */}
        <section id="oferta" className="rounded-2xl border px-6 py-10 text-center" style={{
        borderColor: 'rgba(232,199,102,0.35)',
        background: 'rgba(245,236,228,0.04)'
      }} data-id="element-45">
          <h3 className="text-[22px] leading-snug sm:text-[24px]" style={{
          fontFamily: 'var(--serif)',
          fontWeight: 600,
          color: '#E8C766'
        }} data-id="element-46">
            Una oportunidad que solo aparece hoy
          </h3>
          <div className="mt-5 space-y-4 text-[16px] font-light leading-[1.8]" style={{
          color: 'rgba(245,236,228,0.9)'
        }} data-id="element-47">
            <p data-id="element-48">Este entrenamiento normalmente tiene un valor superior.</p>
            <p data-id="element-49">
              Pero por haber adquirido Kamasutra para Enamorar, puedes añadirlo
              ahora mismo por solo:
            </p>
          </div>

          <p className="my-7 text-[52px] leading-none" style={{
          fontFamily: 'var(--serif)',
          fontWeight: 700,
          background: GOLD_GRADIENT,
          WebkitBackgroundClip: 'text',
          backgroundClip: 'text',
          WebkitTextFillColor: 'transparent'
        }} data-id="element-50">
            USD $10
          </p>

          <div className="space-y-3 text-[15px] font-light leading-[1.7]" style={{
          color: 'rgba(245,236,228,0.9)'
        }} data-id="element-51">
            <p data-id="element-52">Esta oferta solo está disponible en este momento.</p>
            <p data-id="element-53">Si abandonas esta página, desaparecerá.</p>
          </div>

          {/* CONTADOR REGRESIVO */}
          <div className="mt-8" data-id="element-54">
            <p className="text-xs font-medium uppercase tracking-[0.2em]" style={{
            color: 'rgba(245,236,228,0.7)'
          }} data-id="element-55">
              Esta oferta expira en:
            </p>
            <p className="mt-2 text-[40px] leading-none tabular-nums" style={{
            fontFamily: 'var(--serif)',
            fontWeight: 700,
            background: GOLD_GRADIENT,
            WebkitBackgroundClip: 'text',
            backgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }} data-id="element-56">
              {time}
            </p>
          </div>

          {/* WIDGET FUNCIONAL DE HOTMART */}
          <div className="mt-8" data-id="element-57">
            <div id="hotmart-sales-funnel" data-id="element-58" />
          </div>
        </section>

        <Divider data-id="element-59" />

        {/* 7. BLOQUE DE REFLEXIÓN */}
        <div className="text-center" data-id="element-60">
          <h3 className="text-[22px] sm:text-[24px]" style={{
          fontFamily: 'var(--serif)',
          fontWeight: 600,
          color: '#FFFFFF'
        }} data-id="element-61">
            Una reflexión antes de decidir
          </h3>
          <div className="mx-auto mt-6 max-w-[400px] space-y-5 text-[16px] font-light italic leading-[1.9]" style={{
          color: 'rgba(245,236,228,0.9)',
          letterSpacing: '0.015em'
        }} data-id="element-62">
            <p data-id="element-63">Las grandes relaciones no se construyen en una noche.</p>
            <p data-id="element-64">
              Se construyen en los pequeños detalles que elegimos repetir cada
              día.
            </p>
            <p data-id="element-65">Hoy ya decidiste dar el primer paso.</p>
            <p data-id="element-66">No permitas que esa decisión termine aquí.</p>
          </div>
        </div>

        <Divider data-id="element-67" />

        {/* 8. CIERRE */}
        <div className="text-center" data-id="element-68">
          <h3 className="text-[26px] leading-tight sm:text-[30px]" style={{
          fontFamily: 'var(--serif)',
          fontWeight: 700,
          color: '#E8C766'
        }} data-id="element-69">
            18 Métodos para Volver a Elegirse
          </h3>
          <p className="mx-auto mt-4 max-w-[400px] text-[16px] font-light italic leading-[1.7]" style={{
          color: 'rgba(245,236,228,0.9)'
        }} data-id="element-70">
            Cómo evitar que la rutina apague una relación que todavía merece ser
            vivida.
          </p>

          <button type="button" onClick={scrollToOffer} className="mt-8 w-full rounded-full px-6 py-4 text-[15px] font-semibold leading-snug transition-transform duration-200 hover:scale-[1.02] active:scale-[0.99]" style={{
          background: GOLD_GRADIENT,
          color: '#2B0F14',
          boxShadow: '0 8px 30px rgba(201,162,39,0.25)'
        }} data-id="element-71">
            Sí, quiero añadir "18 Métodos para Volver a Elegirse" por solo USD
            $10.
          </button>
        </div>
      </main>

      {/* 9. BARRA STICKY MOBILE */}
      <div className={`fixed inset-x-0 bottom-0 z-50 border-t px-4 py-3 transition-all duration-300 sm:hidden ${showSticky ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-full opacity-0'}`} style={{
      background: 'rgba(13,6,8,0.95)',
      borderColor: 'rgba(232,199,102,0.3)',
      backdropFilter: 'blur(8px)'
    }} data-id="element-72">
        <button type="button" onClick={scrollToOffer} className="flex w-full items-center justify-between gap-3 rounded-full px-5 py-3.5 text-[14px] font-semibold" style={{
        background: GOLD_GRADIENT,
        color: '#2B0F14'
      }} data-id="element-73">
          <span data-id="element-74">Sí, quiero añadir por USD $10</span>
          <span className="tabular-nums opacity-80" data-id="element-75">{time}</span>
        </button>
      </div>
    </div>;
}